import { Table } from 'antd';
import React from 'react';

const CommonTable = props => {
    return (
        <div
            style={{
                height: props.height,
                overflow: props.overflow,
            }}
        >
            <Table
                columns={props.columns}
                dataSource={props.data}
                pagination={props.pagination ?? false}
                loading={props.loading}
                bordered={props.bordered}
                size="middle"
                rowClassName={props.rowClassName}
                // scroll={{y: 490}}

                className={`common-table ${props.customClass ?? ''}`}
                {...props}
                // scroll={{
                //   y: 50000,
                // }}
                // sticky
            />
        </div>
    );
};

export default CommonTable;
